export default __webpack_public_path__ + "static/media/placeholder-5.f12023c3.png";